import React, { useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import Close_x from "../../Asset/icon/closeButton.svg";
import LeftArrow from "../../Asset/icon/whitePrevious.svg";
import RightArrow from "../../Asset/icon/whiteNext.svg";
import "../../Asset/scss/yacht/yachtImageUnder.scss";

const ImageUnderCard = ({ Image }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
    setShowModal(true);
  };

  const handleNextImage = () => {
    const nextIndex = (currentIndex + 1) % Image.length;
    setSelectedImage(Image[nextIndex]);
    setCurrentIndex(nextIndex);
  };

  const handlePreviousImage = () => {
    const previousIndex = (currentIndex - 1 + Image.length) % Image.length;
    setSelectedImage(Image[previousIndex]);
    setCurrentIndex(previousIndex);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Row className="mt-4 mb-4 justify-content-center text-center">
        {Image.slice(0, 6).map((image, index) => (
          <Col key={index} xs={12} sm={12} md={4} lg={2} className="mb-3">
            <img
              className="mx-auto d-block responsive-image-card" // ✅ ทำให้รูปอยู่กึ่งกลาง
              draggable={false}
              src={image}
              alt="imageUnder"
              onClick={() => handleImageClick(image, index)}
            />
          </Col>
        ))}
      </Row>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="modal-fullscreen"
      >
        <Modal.Body className="d-flex justify-content-center align-items-center">
          <div className="position-relative">
            <img
              src={selectedImage}
              draggable={false}
              alt="selectedImage"
              className="image-fit-screen"
            />
            <button
              className="modal-nav-button left-10rem"
              onClick={handlePreviousImage}
            >
              <img
                src={LeftArrow}
                alt="Previous"
                draggable={false}
                className="size-5vh"
              />
            </button>
            <button
              className="modal-nav-button right-10rem"
              onClick={handleNextImage}
            >
              <img
                src={RightArrow}
                alt="Next"
                draggable={false}
                className="size-5vh"
              />
            </button>
            <div className="modal-dot-container">
              {Image.map((_, index) => (
                <span
                  key={index}
                  onClick={() => {
                    setSelectedImage(Image[index]);
                    setCurrentIndex(index);
                  }}
                  className={`modal-dot ${currentIndex === index ? "active" : ""
                    }`}
                />
              ))}
            </div>
            <button
              className="btn modal-close-button"
              onClick={handleCloseModal}
            >
              <img
                src={Close_x}
                alt="Close"
                draggable={false}
                className="floating-action"
              />
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ImageUnderCard;
